/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Fulfillment_Not_ReleasableInputs */

const en_error_fulfillment_not_releasable = /** @type {(inputs: Error_Fulfillment_Not_ReleasableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The shipment cannot go to the warehouse in its current status.`)
};

/**
* | output |
* | --- |
* | "The shipment cannot go to the warehouse in its current status." |
*
* @param {Error_Fulfillment_Not_ReleasableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_fulfillment_not_releasable = /** @type {((inputs?: Error_Fulfillment_Not_ReleasableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Fulfillment_Not_ReleasableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_fulfillment_not_releasable(inputs)
});